import React from 'react';
import PropTypes from "prop-types";
import { CsfPivotalFournisseurRecognitionDetailsTab1 } from "./csf-fournisseur-recognition-details-tab1";
import { CsfPivotalFournisseurRecognitionDetailsTab2 } from "./csf-fournisseur-recognition-details-tab2";
import { CsfPivotalFournisseurRecognitionDetailsTab3 } from "./csf-fournisseur-recognition-details-tab3";
import { CsfPivotalFournisseurRecognitionDetailsTab4 } from "./csf-fournisseur-recognition-details-tab4";
import { CsfPivotalFournisseurRecognitionDetailsTab5 } from "./csf-fournisseur-recognition-details-tab5";
import {formatDate} from "../includes/utils";

export function CsfPivotalFournisseurRecognitionDetails({formDetail, contact, trainers, accessToken, apiUrl, apiEnv, trainingUfcInfo, allMatiereInfo}) {

  function handleTabs(e) {
    e.preventDefault();
    const currentNav = document.querySelector('.recognition-details .nav-item .is-active');
    const currentTab = document.querySelector('.recognition-details .tab-panel:not(.hide)');
    const tab = document.querySelector(e.target.dataset.tab);

    // Reset
    currentNav.classList.remove('is-active');
    currentNav.setAttribute('aria-selected', 'false');
    currentTab.classList.add('hide');

    // Activate the clicked nav item and tab
    e.target.classList.add('is-active');
    e.target.setAttribute('aria-selected', 'true');
    tab.classList.remove('hide');
  }

  return (
    <div className="primary recognition-details d-flex flex-column">
      <div className="space-between-wrapper">
        <h2>{window.Drupal.t('fournisseur.recognition.detail.details.title')}</h2>

        {formDetail.Recognition_Code && (
          <p className="recognition-detail-number">
            {window.Drupal.t('fournisseur.recognition.detail.details.numlabel')} : <i>#</i>{formDetail.Recognition_Code}
          </p>
        )}
      </div>

      <div className="inner-wrapper">
        <div className="nav-tabs-wrapper">
          <ul className="d-flex nav-tabs">
            <li className="nav-item">
              <a href="#" onClick={handleTabs} className="is-active" data-tab="#ask-tab" type="button" role="tab" aria-controls="ask-tab" aria-selected="true">
                {window.Drupal.t('fournisseur.recognition.detail.details.tab1')}
              </a>
            </li>
            <li className="nav-item">
              <a href="#" onClick={handleTabs} data-tab="#training-tab" type="button" role="tab" aria-controls="training-tab" aria-selected="false">
                {window.Drupal.t('fournisseur.recognition.detail.details.tab2')}
              </a>
            </li>
            <li className="nav-item">
              <a href="#" onClick={handleTabs} data-tab="#content-tab" type="button" role="tab" aria-controls="content-tab" aria-selected="false">
                {window.Drupal.t('fournisseur.recognition.detail.details.tab3')}
              </a>
            </li>
            <li className="nav-item">
              <a href="#" onClick={handleTabs} data-tab="#trainers-tab" type="button" role="tab" aria-controls="trainers-tab" aria-selected="false">
                {window.Drupal.t('fournisseur.recognition.detail.details.tab4')}
              </a>
            </li>
            <li className="nav-item">
              <a href="#" onClick={handleTabs} data-tab="#recognition-tab" type="button" role="tab" aria-controls="recognition-tab" aria-selected="false">
                {window.Drupal.t('fournisseur.recognition.detail.details.tab5')}
              </a>
            </li>
          </ul>
        </div>

        <div className="tab-content">
          <CsfPivotalFournisseurRecognitionDetailsTab1 formDetail={formDetail} contact={contact}/>
          <CsfPivotalFournisseurRecognitionDetailsTab2 formDetail={formDetail}/>
          <CsfPivotalFournisseurRecognitionDetailsTab3 formDetail={formDetail} accessToken={accessToken} apiUrl={apiUrl} apiEnv={apiEnv}/>
          <CsfPivotalFournisseurRecognitionDetailsTab4 trainers={trainers} accessToken={accessToken} apiUrl={apiUrl} apiEnv={apiEnv}/>
          <CsfPivotalFournisseurRecognitionDetailsTab5 formDetail={formDetail} trainingUfcInfo={trainingUfcInfo} allMatiereInfo={allMatiereInfo}/>
        </div>
      </div>
    </div>
  );
}

CsfPivotalFournisseurRecognitionDetails.propTypes = {
  formDetail: PropTypes.object,
  contact: PropTypes.object,
  trainers: PropTypes.array,
  accessToken: PropTypes.string,
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  trainingUfcInfo: PropTypes.object,
  allMatiereInfo: PropTypes.array
};
